export interface FAQItem {
  questionKey: string; // Clé de traduction au lieu du texte
  answerKey: string; // Clé de traduction au lieu du texte
}

export const faqData: FAQItem[] = [
  {
    questionKey: "items.0.question",
    answerKey: "items.0.answer",
  },
  {
    questionKey: "items.1.question",
    answerKey: "items.1.answer",
  },
  {
    questionKey: "items.2.question",
    answerKey: "items.2.answer",
  },
  {
    questionKey: "items.3.question",
    answerKey: "items.3.answer",
  },
  {
    questionKey: "items.4.question",
    answerKey: "items.4.answer",
  },
];
